import React from 'react';

import { Loader } from '../../../Loader';
import { Mainbar } from '../../styles';
import { SoftBlockHint } from './components/SoftBlockHint';
import { useWithdrawSoftBlock } from '../../../../hooks/useWithdrawSoftBlock';

interface Props {
  children: React.ReactElement;
}

export const SoftBlockChecker: React.FC<Props> = ({ children }) => {
  const { expirationDate, isBlocked, loading } = useWithdrawSoftBlock();

  if (loading) return <Loader />;

  return (
    children && (
      <Mainbar>{isBlocked ? <SoftBlockHint expirationDate={expirationDate} /> : children}</Mainbar>
    )
  );
};
